import { ConversionRateContainer } from "./index.styled";

const CardConversionRate = ({ conversionRate }: { conversionRate: number }) => {
  return (<ConversionRateContainer>
    <div className="conversion-rate-title">יחס המרה</div>
    <div className="conversion-rate-value">{conversionRate}%</div>
  </ConversionRateContainer>);
};

export default CardConversionRate;